var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"bordered":true}},[_c('TablePage',{attrs:{"list":_vm.tableConfig},on:{"onPageChange":_vm.onPageChange,"onPageSizeChange":_vm.onPageSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }